<template>
  <el-row
    class="organizations"
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $t('menu.organizations') }}
        </h3>
      </el-header>
      <el-main class="organizations-body">
        <div class="organizations-body-search">
          <el-input
            v-model="searchQuery"
            placeholder="Search"
            @input="setSearchQuery"
          />
        </div>
        <el-collapse
          v-model="activeCollapse"
        >
          <el-collapse-item
            class="primary-outline"
            v-for="(organization, index) in filteredOrganizations"
            :key="index"
          >
            <template slot="title">
              <img
                :src="`https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${organization.logo || 'profile.png'}?t=${new Date().getTime()}`"
                :alt="organization.name"
                width="40px"
                height="40px"
              >
              <div class="title">
                <p class="organizations-collapse-title">
                  {{ organization.name }}
                </p>
              </div>
            </template>
            <div class="rows-wrapper">
              <div class="row">
                <span class="property">{{ $t('organization.name') }}</span>
                <span class="value">{{ organization.name }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t('organization.resp-contact') }}</span>
                <span class="value">
                  {{ organization.representativeName }}
                  {{ organization.representativeLastname }}
                </span>
              </div>
            </div>
            <router-link
              :to="{name: 'Organization', params: { id: organization.id } }"
              custom
              v-slot="{ navigate }"
            >
              <el-button
                type="primary"
                class="primary-button"
                @click="navigate"
              >
                {{ $t('form.details') }}
              </el-button>
            </router-link>
          </el-collapse-item>
        </el-collapse>
        <router-link
          v-if="isAdmin"
          :to="{name: 'CreateOrganization'}"
          custom
          v-slot="{ navigate }"
        >
          <el-button
            type="primary"
            class="primary-button create-organization"
            @click="navigate"
          >
            {{ $t('organization.create-new') }}
          </el-button>
        </router-link>
        <el-pagination
          v-if="this.allOrganizations.length"
          class="organizations-body-pagination"
          layout="prev, pager, next"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          @current-change="changePage"
        />
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from '@/views/Menu/Menu';
import authHelpers from '@/plugins/auth-helpers';

export default {
  name: 'Organizations',
  components: {
    Menu
  },
  data: function () {
    return {
      isAdmin: false,
      fullScreenLoading: true,
      organizations: [],
      allOrganizations: [],
      activeCollapse: [],
      searchQuery: this.$route.query.s || '',
      currentPage: (this.$route.params.page) ? parseInt(this.$route.params.page) : 1
    };
  },
  computed: {
    pageCount: function () {
      return Math.ceil(this.organizations.length / 20);
    },
    filteredOrganizations: function () {
      const offset = (this.currentPage - 1) * 20;
      const limit = offset + 20;

      return this.organizations.length ? this.organizations.slice(offset, limit) : [];
    }
  },
  created () {
    authHelpers.isCurrentUserAdmin().then((response) => {
      this.isAdmin = response;
    });
    this.getCurrentUser().then((user) => {
      this.$adminApi.get('/api/v1/entities/employees/' + user.attributes.sub).then((response) => {
        this.organizations = this.allOrganizations = response.data;
        this.searchOrganizations();
        this.fullScreenLoading = false;
      })
        .catch(() => {
          this.fullScreenLoading = false;
        });
    })
      .catch(() => {
        this.fullScreenLoading = false;
      });
  },
  watch: {
    '$route.query.s': function () {
      this.searchOrganizations();
    }
  },
  methods: {
    searchOrganizations () {
      if (this.searchQuery.length) {
        this.organizations = this.allOrganizations.filter((el) => {
          return el.name.toLowerCase().includes(this.searchQuery.toLowerCase());
        }) || [];
      } else {
        this.organizations = this.allOrganizations;
      }
    },
    setSearchQuery (query = '') {
      if (query.length) {
        this.$router.push({
          name: 'Organizations',
          query: { 's': query }
        });
      } else {
        this.$router.push({
          name: 'Organizations'
        });
      }
    },
    changePage (page) {
      if (page > 1) {
        this.$router.push({
          name: 'Organizations',
          params: { page: page },
          query: { ...(this.searchQuery ? { s: this.searchQuery } : {}) }
        });
      } else {
        this.$router.push({
          name: 'Organizations',
          query: { ...(this.searchQuery ? { s: this.searchQuery } : {}) }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.create-organization {
  margin-bottom: 50px;
}

.organizations {
  &-body {
    margin-top: 30px;
    padding: 0 16px;

    &-search {
      margin-bottom: 20px;
    }

    &-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;
    }
  }
}
</style>
